/* By Layla Saleh — virtual try-on usage tracking.
 *
 * The try-on shipped with no instrumentation, so there was no way to answer
 * "has anyone actually used this?". This file adds that WITHOUT touching
 * vton-engine.js: the engine stores its instance on the root element as
 * __vton, so its prototype can be wrapped from outside. Keeping it separate
 * means the engine stays exactly as shipped and this can be removed by
 * deleting one script tag.
 *
 * Four events, because one number would mislead — someone who clicks and then
 * blocks the camera has not tried the glasses on:
 *
 *   virtual_tryon_opened    they clicked the button
 *   virtual_tryon_started   camera live, model loaded, tracking running
 *   virtual_tryon_snapshot  they liked it enough to save the photo
 *   virtual_tryon_failed    opened but never got going, with the reason
 *
 * Each carries the frame name, so it answers "which glasses do people try?".
 */
(function () {
  'use strict';

  /* Two destinations, because neither alone is enough. Shopify.analytics is the
     documented storefront event bus, so any Web Pixel can subscribe and the data
     survives swapping analytics tools. Clarity is what is installed on this
     store today and is the only place these numbers are readable right now.

     Fire-and-forget: an ad blocker removing one of these globals is the normal
     case, not an exceptional one, so nothing here may ever throw into the
     try-on. A blocked tracker must not stop someone seeing the glasses. */
  function track(event, params) {
    var p = params || {};
    try {
      if (window.Shopify && window.Shopify.analytics &&
          typeof window.Shopify.analytics.publish === 'function') {
        window.Shopify.analytics.publish(event, p);
      }
    } catch (e) {}
    try {
      if (typeof window.clarity === 'function') {
        window.clarity('event', event);
        // Clarity's filter panel exposes custom TAGS, not event names, so the
        // event is mirrored into a tag as well. Without this the funnel is not
        // filterable in the UI at all: you could see that the try-on was used
        // but not whether the camera ever started.
        window.clarity('set', 'vton_event', event.replace('virtual_tryon_', ''));
        // A custom tag makes Clarity sessions filterable by frame, which turns
        // "someone used it" into "which frames people try".
        if (p.frame) window.clarity('set', 'vton_frame', p.frame);
        if (p.reason) window.clarity('set', 'vton_failure', p.reason);
      }
    } catch (e) {}
    try {
      if (typeof window.gtag === 'function') window.gtag('event', event, p);
    } catch (e) {}
  }

  var wrapped = false;

  function wrapPrototype(instance) {
    if (wrapped) return;
    var proto = Object.getPrototypeOf(instance);
    if (!proto || typeof proto.open !== 'function') return;
    wrapped = true;

    var open = proto.open;
    proto.open = function () {
      track('virtual_tryon_opened', { frame: this.productName });
      return open.apply(this, arguments);
    };

    // fail() is the engine's single funnel for every camera / device error,
    // so its title is a ready-made failure reason.
    if (typeof proto.fail === 'function') {
      var fail = proto.fail;
      proto.fail = function (title) {
        track('virtual_tryon_failed', {
          frame: this.productName,
          reason: title || 'unknown'
        });
        return fail.apply(this, arguments);
      };
    }

    if (typeof proto.snapshot === 'function') {
      var snapshot = proto.snapshot;
      proto.snapshot = function () {
        track('virtual_tryon_snapshot', { frame: this.productName });
        return snapshot.apply(this, arguments);
      };
    }
  }

  /* "Started" has no method of its own — the engine marks success by revealing
     the actions bar once the camera, the model and the face tracker are all up.
     Watching that attribute is therefore the same signal, observed instead of
     called. Fires once per open; reset when the modal closes. */
  function watchStarted(root) {
    var actions = root.querySelector('[data-vton-actions]');
    if (!actions || typeof MutationObserver !== 'function') return;
    var fired = false;
    new MutationObserver(function () {
      var visible = !actions.hasAttribute('hidden');
      if (visible && !fired) {
        fired = true;
        track('virtual_tryon_started', {
          frame: root.getAttribute('data-product-title') || 'unknown'
        });
      } else if (!visible) {
        fired = false;
      }
    }).observe(actions, { attributes: true, attributeFilter: ['hidden'] });
  }

  function attach() {
    var roots = document.querySelectorAll('[data-vton-root]');
    for (var i = 0; i < roots.length; i++) {
      var root = roots[i];
      if (root.__vtonTracked) continue;
      if (!root.__vton) continue;          // engine has not initialised yet
      root.__vtonTracked = true;
      try {
        wrapPrototype(root.__vton);
        watchStarted(root);
      } catch (e) {}
    }
  }

  /* The engine initialises on DOMContentLoaded and again on section load, and
     this file cannot guarantee it runs after either. Poll briefly instead of
     racing: cheap, bounded, and it copes with the engine arriving late. */
  function boot() {
    var tries = 0;
    var timer = setInterval(function () {
      attach();
      if (++tries > 40 || wrapped) clearInterval(timer);   // give up after ~10s
    }, 250);
    attach();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', attach);
})();